import showPopup from '@a/components/showPopup'
import SaquePopup from '@/components/Meu/saque.vue'
import { checkWithdrawalPassword } from '@/api/saque'
import showLoginOrRegPopup from '@a/components/showLoginOrRegPopup'
import { useUserInfo } from '@/store'
let isLoading = false
export async function handleSaqueClick(router: any) {
  const isLogin = useUserInfo().isLoggedin
  if (!isLogin) {
    showLoginOrRegPopup()
    return
  }
  if (isLoading) return
  isLoading = true

  try {
    showLoadingToast({
      message: 'loading...',
      zIndex: 2999,
    })

    const res = await checkWithdrawalPassword({
      value: '',
    })
    if (res.code === 1) {
      router.push('/choosesaque')
    } else if (res.code === -3700) {
      showPopup(SaquePopup)
    }
  } catch (error) {
    console.error(error)
  } finally {
    isLoading = false
    closeToast()
  }
}
